import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { PRIORITIES } from "@/components/settings/bulkTaxonomyHelpers";

/**
 * Renders a single cell of the bulk taxonomy grid — switches between
 * boolean / priority dropdown / dept-or-case dropdown / plain text input.
 */
export default function BulkTaxonomyCell({ col, value, error, depts, caseTypes, onChange, onPaste }) {
  const ringClass = error
    ? "border-rose-300 bg-rose-50 ring-1 ring-rose-200"
    : "border-transparent hover:border-slate-200 focus-within:border-indigo-400 focus-within:bg-indigo-50/30";

  const td = `px-1 py-0.5 ${col.w}`;

  if (col.boolean) {
    return (
      <td className={td}>
        <div className="flex justify-center">
          <Checkbox
            checked={value === "true" || value === true}
            onCheckedChange={(v) => onChange(v ? "true" : "false")}
            data-testid={`cell-${col.key}`}
          />
        </div>
      </td>
    );
  }

  if (col.dropdown === "priority") {
    return (
      <td className={td} data-testid={`cell-${col.key}`}>
        <div className={`rounded border ${ringClass}`} title={error || ""}>
          <Select value={value || "medium"} onValueChange={onChange}>
            <SelectTrigger className="h-7 text-xs border-none px-2"><SelectValue /></SelectTrigger>
            <SelectContent>
              {PRIORITIES.map((p) => (
                <SelectItem key={p} value={p} className="text-xs capitalize">{p}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </td>
    );
  }

  if (col.dropdown === "dept" || col.dropdown === "case") {
    const options = col.dropdown === "dept" ? depts : caseTypes;
    const hasMatch = !value || options.some((o) => o.name === value);
    return (
      <td className={td} data-testid={`cell-${col.key}`}>
        <div className={`rounded border ${ringClass}`} title={error || ""}>
          <Select value={hasMatch ? (value || "") : value} onValueChange={onChange}>
            <SelectTrigger className="h-7 text-xs border-none px-2 truncate">
              <SelectValue placeholder="—">{value || "—"}</SelectValue>
            </SelectTrigger>
            <SelectContent>
              {options.map((o) => (
                <SelectItem key={o.id} value={o.name} className="text-xs">{o.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </td>
    );
  }

  return (
    <td className={td}>
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        onPaste={onPaste}
        title={error || ""}
        className={`w-full h-7 px-2 text-xs rounded border bg-transparent outline-none ${ringClass}`}
        data-testid={`cell-${col.key}`}
      />
    </td>
  );
}
